import { getLoggedUser } from './../../../utils/helpers/tokenStorage';
import { selectCurrentUser } from './../../../store/selectors/authSelectors';
import { selectDeliveryWizardData } from './../../../store/selectors/deliveryWizardSelector';
import { useAppSelector, useAppDispatch } from './../../../store/hooks';
import { useEffect, useState } from "react";
import { useGetAllClientsQuery } from "../../../api/clientAPI";
import { ClientSubtypeE, ClientTypeE } from "../../../models/enums";
import { ClientT } from "../../../models/models";
import { addDestination, removeDestination } from '../../../store/slices/deliveryWizardSlice';

export const useDestinations = () => {
    const { data: clients } = useGetAllClientsQuery({});
    const BroadcasterIds = useAppSelector(selectDeliveryWizardData)?.delivery?.BroadcasterIds || '';
    const user = getLoggedUser()?.user?.user;
    const dispatch = useAppDispatch();

    const [tvChannels, setTvChannels] = useState<ClientT[]>([]);
    const [movieTheatres, setMovieTheatres] = useState<ClientT[]>([]);

    useEffect(() => {
        if (clients) {
            const filteredTvChannels = clients
                .filter((client: ClientT) => (+client.ClientType === ClientTypeE.Broadcaster) && client.ClientSubType === ClientSubtypeE.None)
                .filter((client: ClientT) => user.clientType === ClientTypeE.Broadcaster ? client.Id === +user.id : true);
                
            const filteredMovieTheatres = clients
                .filter((client: ClientT) => (+client.ClientType === ClientTypeE.Broadcaster) && client.ClientSubType === ClientSubtypeE['Broadcaster - Cinema'])
                .filter((client: ClientT) => user.clientType === ClientTypeE.Broadcaster ? client.Id === +user.id : true);
            setTvChannels(filteredTvChannels);
            setMovieTheatres(filteredMovieTheatres);
        }
    }, [clients]);

    const selectDestination = (destination: number) => {
        if (BroadcasterIds?.split(',')?.map(item => +item)?.includes(destination)) {
            dispatch(removeDestination(+destination));
        } else {
            dispatch(addDestination(+destination));
        }
    };

    return { tvChannels, movieTheatres, selectDestination };
};